import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=0e0ad9a7&"
import script from "./Setting.vue?vue&type=script&lang=js&"
export * from "./Setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0ad9a7')) {
      api.createRecord('0e0ad9a7', component.options)
    } else {
      api.reload('0e0ad9a7', component.options)
    }
    module.hot.accept("./Setting.vue?vue&type=template&id=0e0ad9a7&", function () {
      api.rerender('0e0ad9a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Setting/Setting.vue"
export default component.exports